import { Box, CircularProgress, Stack, SxProps, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import { COLOR_MAIN } from "../../data/colors/Colors";

interface ImageViewDetails {
  src?: string | null;
  width: string | number;
  height: string | number;
  scale?: string;
  props?: SxProps<Theme>;
  onLoaded?: () => void;
}

export const CustomImageView: React.FC<ImageViewDetails> = ({
  src,
  width,
  height,
  scale = "cover",
  props,
  onLoaded,
}: ImageViewDetails) => {
  const [loaded, setLoaded] = useState(false);

  return src ? (
    <Stack
      position={"relative"}
      sx={[
        {
          width: width,
          height: height,
        },
        ...(Array.isArray(props) ? props : [props]),
      ]}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box
        component="img"
        src={src}
        onLoad={() => {
          if (onLoaded) onLoaded();
          setLoaded(true);
        }}
        sx={[
          {
            width: width,
            height: height,
            objectFit: scale,
          },
          ...(Array.isArray(props) ? props : [props]),
        ]}
      />
      {!loaded && (
        <Stack
          alignItems={"center"}
          justifyContent={"center"}
          position={"absolute"}
          zIndex={20}
        >
          <CircularProgress sx={{ color: COLOR_MAIN }} />
        </Stack>
      )}
    </Stack>
  ) : (
    <></>
  );
};
